import { WORKFLOW_CONFIG, Workflow } from "../config/workflowConfig";

interface WorkflowSelectorProps {
  value: Workflow;
  onChange: (workflow: Workflow) => void;
  disabled?: boolean;
}

export function WorkflowSelector({ value, onChange, disabled }: WorkflowSelectorProps) {
  return (
    <div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Workflow
      </p>
      <div className="grid grid-cols-2 gap-2">
        {(Object.keys(WORKFLOW_CONFIG) as Workflow[]).map((key) => {
          const cfg = WORKFLOW_CONFIG[key];
          const active = value === key;
          return (
            <button
              key={key}
              type="button"
              disabled={disabled}
              onClick={() => onChange(key)}
              className={`rounded-xl border px-3 py-2.5 text-left transition ${
                active
                  ? "border-brand-navy bg-brand-navy text-white shadow-sm"
                  : "border-gray-200 bg-white text-gray-700 hover:border-brand-accent/50"
              } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
            >
              <span className="block text-sm font-semibold">{cfg.label}</span>
              <span
                className={`mt-0.5 block text-xs ${active ? "text-white/80" : "text-gray-500"}`}
              >
                {cfg.description}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
